
import { vehicleDetail } from './vehicleDetail'
import { spottedDetail } from './spottedDetail'
import { dealer } from './dealer'
import { makeModel } from './makeModel'
import { bodyType } from './bodyType'
import { usedCategory } from './usedCategory'
import { usedMakeBodyType } from './usedMakeBodyType'
import { awardWinningVehicleDetail } from './awardWinningVehicleDetail'

export const metaApi = {
  vehicleDetail,
  spottedDetail,
  dealer,
  makeModel,
  bodyType,
  usedMakeBodyType,
  usedCategory,
  awardWinningVehicleDetail
}